import { Project } from "../projectSlice";
import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Localized } from "@fluent/react";

type ArchivedProjectAlertProps = {
    project: Project;
};

export const ArchivedProjectAlert: React.FC<ArchivedProjectAlertProps> = ({ project }) => {
    return (
        <Alert
            severity="warning"
            icon={<WarningAmberIcon />}
            sx={{ mb: 2, borderRadius: 2 }}
        >
            <AlertTitle>
                <Localized id="archived-project">_Projekt zarchiwizowany</Localized>
            </AlertTitle>
            <Stack spacing={0.5}>
                <Typography variant="body2">
                    <Localized
                        id="archived-project-restriction-info"
                        elems={{ b: <strong /> }}
                    >
                        <span />
                    </Localized>
                </Typography>
                <Typography variant="body2">
                    <b><Localized id="date">_Data:</Localized></b> {project.archivedAt ? new Date(project.archivedAt).toISOString().split('T')[0] : ""}
                </Typography>
                {project.archivedBy && (
                    <Typography variant="body2">
                        <b><Localized id="archived-by">_Przez:</Localized></b> {project.archivedBy}
                    </Typography>
                )}

            </Stack>
        </Alert>
    )
};